module.exports = __webpack_public_path__ + "static/media/person.373c9aa1.svg";